import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tag-subscipt",
  "use": "icon-tag-subscipt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tag-subscipt\"><path d=\"M448 853.333333L170.666667 576 576 170.666667H853.333333v277.333333L448 853.333333z m0-119.466666L768 426.666667V256h-170.666667l-307.2 320 157.866667 157.866667zM682.666667 298.666667c25.6 0 42.666667 17.066667 42.666666 42.666666s-17.066667 42.666667-42.666666 42.666667-42.666667-17.066667-42.666667-42.666667 17.066667-42.666667 42.666667-42.666666z\" p-id=\"7954\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/tag-subscipt.svg
// module id = sM2q
// module chunks = 12